module.exports = __webpack_public_path__ + "img/icon_close.5669a641.svg";